interface Props {
  anchorId?: string;
  videoId?: string;
  citeUrl?: string;
  authorId?: string;
  title?: string;
}

const TikTok = ({ anchorId, videoId, citeUrl, authorId, title }: Props) => {
  return (
    <div id={anchorId} style={{ padding: '0.25rem' }}>
      <blockquote
        className="tiktok-embed max-w-[325px] rounded-sm"
        cite={citeUrl}
        data-video-id={videoId}
        data-from-oembed
      >
        <section>
          <a target="_blank" title={`@${authorId}`} href={`https://www.tiktok.com/@${authorId}`} rel="noreferrer">
            @{authorId}
          </a>
          <p>{title}</p>
        </section>
      </blockquote>
    </div>
  );
};

export { TikTok };
